import React from "react";
import ProfileTitle from "../../../../components/ProfileTitle";
import * as api from '../../../../apis/platforms/admin/baseData'
import useAntTable from "../../../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Button, Divider, Popconfirm, Space} from "antd";
import CurrencyEditModal from "./currencyEditModal";
import useFormModal from "../../../../utils/useFormModal";
import DealerGroupEditModal from "./dealerGroupEditModal";
import {useRequest} from "ahooks";

export default function DealerGroup() {

    const {tableProps, refresh} = useAntTable(api.getDealerGroups, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.editDealerGroup,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteDealerGroup, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '客户组',
            dataIndex: 'dealerGroup'
        },
        {
            title: '描述',
            dataIndex: 'desc'
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Space split={<Divider type="vertical" />}>
                    <a onClick={() => {
                        setVisible(true, record)
                    }}>编辑</a>
                    <Popconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </Popconfirm>
                </Space>
            )
        }
    ]

    return (
        <div>
            <ProfileTitle>客户组</ProfileTitle>
            <StandardTable {...tableProps} columns={columns} showCard={false} rowKey={'id'} toolbar={
                <Button type={'primary'} onClick={() => setVisible(true)}>新增</Button>
            }/>
            <DealerGroupEditModal {...modalProps}/>
        </div>
    )
}
